import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import dayjs from 'dayjs';
import { uniq } from 'lodash';
import { getAdminWorkCalendarDataForProjectInTimeFrame } from 'scenes/WorkDemo/services/getAdminWorkCalendarDataForProjectInTimeFrame.service';
import { returnMonthlySearchesTimeFrames } from 'scenes/WorkDemo/utils/returnMonthlySearchesTimeFrames.util';
import { loadAssignmentsForProjects } from 'store/assignments/thunks/loadAssignmentsForProjects';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { loadRecordAllowancesOfEmployerInTimeframe } from 'store/recordAllowances/thunks/loadRecordAllowancesOfEmployerInTimeframe.thunk';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const loadAdminCalendarRecordsDataInTimeframe = createAsyncThunk(
  'workCalendar/loadAdminCalendarRecordsDataInTimeframe',
  async (_, { getState, dispatch }) => {
    const state = getState();

    const { workSearchParams_demo } = state;

    const selectedProjectId = selectSelectedProjectId(state);

    const fromDate = dayjs(workSearchParams_demo.fromDate);
    const toDate = dayjs(workSearchParams_demo.toDate);

    const searchMonthDifference = toDate.diff(fromDate, 'month');

    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());

    let recordsData = [];

    dispatch(
      loadRecordAllowancesOfEmployerInTimeframe({
        fromDate: workSearchParams_demo.fromDate,
        toDate: workSearchParams_demo.toDate,
      })
    );

    if (searchMonthDifference > 0) {
      const monthlySearches = returnMonthlySearchesTimeFrames(fromDate, toDate);

      console.log('monthly searches', monthlySearches);

      const monthlyRecordsSearches = Promise.all(
        monthlySearches.map((monthlySearch) => {
          const apiPath = `workflow/admin-request/${selectedProjectId}/${monthlySearch.fromDate}/${monthlySearch.toDate}`;

          return createSignedGetRequest({
            apiPath,
            activeEmployerInfo,
          });
        })
      );

      const [recordsSignedRequests] = await Promise.all([
        monthlyRecordsSearches,
      ]);

      const recordsRequestsPromises = Promise.all(
        recordsSignedRequests.map((request) =>
          axios(request).then((res) => res.data)
        )
      );

      const [recordsResponses] = await Promise.all([recordsRequestsPromises]);

      recordsData = {
        records: recordsResponses.map((response) => response.records).flat(),
      };
    } else {
      const recordsResponse =
        await getAdminWorkCalendarDataForProjectInTimeFrame(
          selectedProjectId,
          workSearchParams_demo.fromDate,
          workSearchParams_demo.toDate,
          activeEmployerInfo
        );

      const { records } = recordsResponse;

      recordsData = { records };
    }

    const calendarDataRecords = recordsData.records || [];

    const recordsProjectIds = uniq(
      calendarDataRecords
        .filter((record) => record.assignment)
        .map((record) => record.project)
    );

    dispatch(loadAssignmentsForProjects(recordsProjectIds));

    return recordsData;
  }
);
